import { SetStateAction } from "react";
import { ModalWithButtons } from "./modal";
import { BlackButton, GreyButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function DeleteSampleConfirmModal(props: Props) {
	const { t: translation } = useTranslation();

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<GreyButton
					key="delete-sample-cancel-button"
					id="delete-sample-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></GreyButton>,
				<BlackButton
					key="delete-sample-proceed-button"
					id="delete-sample-proceed-button"
					children={translation("Delete")}
					onClick={() => {
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></BlackButton>,
			]}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "5px",
					alignItems: "center",
					textAlign: "center",
					marginTop: "-10px",
				}}
			>
				<div className="modal-body-icon delete-sample-icon"></div>

				<div className="typography-body-02 typography-bold">
					{translation("Deletesample?")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("DeleteSampleMessage")}
				</div>
				{/* <div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("DeleteSampleMessageProceed")}
				</div> */}
			</div>
		</ModalWithButtons>
	);

	return modal;
}
